!(function (e) {
    var t = {};
    function n(r) {
        if (t[r]) return t[r].exports;
        var i = (t[r] = { i: r, l: !1, exports: {} });
        return e[r].call(i.exports, i, i.exports, n), (i.l = !0), i.exports;
    }
    (n.m = e),
        (n.c = t),
        (n.d = function (e, t, r) {
            n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: r });
        }),
        (n.r = function (e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
        }),
        (n.t = function (e, t) {
            if ((1 & t && (e = n(e)), 8 & t)) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var r = Object.create(null);
            if ((n.r(r), Object.defineProperty(r, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e))
                for (var i in e)
                    n.d(
                        r,
                        i,
                        function (t) {
                            return e[t];
                        }.bind(null, i)
                    );
            return r;
        }),
        (n.n = function (e) {
            var t =
                e && e.__esModule
                    ? function () {
                          return e.default;
                      }
                    : function () {
                          return e;
                      };
            return n.d(t, "a", t), t;
        }),
        (n.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (n.p = ""),
        n((n.s = 2));
})([
    function (e, t, n) {
        !(function (e) {
            "use strict";
            function t(e) {
                return (t =
                    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                        ? function (e) {
                              return typeof e;
                          }
                        : function (e) {
                              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                          })(e);
            }
            function n(e, t, n) {
                return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n), e;
            }
            function r(e, t) {
                var n = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(e);
                    t &&
                        (r = r.filter(function (t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })),
                        n.push.apply(n, r);
                }
                return n;
            }
            function i(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var i = null != arguments[t] ? arguments[t] : {};
                    t % 2
                        ? r(Object(i), !0).forEach(function (t) {
                              n(e, t, i[t]);
                          })
                        : Object.getOwnPropertyDescriptors
                        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i))
                        : r(Object(i)).forEach(function (t) {
                              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
                          });
                }
                return e;
            }
            function o(e, t, n) {
                var r,
                    i = "";
                if ((e = "number" == typeof e ? String(e) : e).length > t) return e;
                for (r = 0; r < t; r += 1) i += String(n);
                return (i + e).slice(-i.length);
            }
            function a() {
                this.reset();
            }
            function s() {
                this.events = {};
            }
            (a.prototype.toString = function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ["hours", "minutes", "seconds"],
                    t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ":",
                    n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 2;
                (e = e || ["hours", "minutes", "seconds"]), (t = t || ":"), (n = n || 2);
                var r,
                    i = [];
                for (r = 0; r < e.length; r += 1) void 0 !== this[e[r]] && ("secondTenths" === e[r] ? i.push(this[e[r]]) : i.push(o(this[e[r]], n, "0")));
                return i.join(t);
            }),
                (a.prototype.reset = function () {
                    (this.secondTenths = 0), (this.seconds = 0), (this.minutes = 0), (this.hours = 0), (this.days = 0);
                }),
                (s.prototype.on = function (e, t) {
                    var n = this;
                    return (
                        Array.isArray(this.events[e]) || (this.events[e] = []),
                        this.events[e].push(t),
                        function () {
                            return n.removeListener(e, t);
                        }
                    );
                }),
                (s.prototype.removeListener = function (e, t) {
                    if (Array.isArray(this.events[e])) {
                        var n = this.events[e].indexOf(t);
                        n > -1 && this.events[e].splice(n, 1);
                    }
                }),
                (s.prototype.emit = function (e) {
                    for (var t = this, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) r[i - 1] = arguments[i];
                    Array.isArray(this.events[e]) &&
                        this.events[e].forEach(function (e) {
                            return e.apply(t, r);
                        });
                });
            var c = "seconds",
                l = "hours",
                u = "days",
                d = ["secondTenths", c, "minutes", l, u],
                h = { secondTenths: 100, seconds: 1e3, minutes: 6e4, hours: 36e5, days: 864e5 },
                m = { secondTenths: 10, seconds: 60, minutes: 60, hours: 24 };
            function y(e, t) {
                return ((e % t) + t) % t;
            }
            function p() {
                var e,
                    n,
                    r,
                    o,
                    p,
                    f,
                    g,
                    v,
                    b,
                    w,
                    S = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    E = new a(),
                    L = new a(),
                    T = new s(),
                    q = !1,
                    A = !1,
                    C = {},
                    _ = { detail: { timer: this } };
                function k(e, t) {
                    (L[e] = t), (E[e] = e === u ? t : t >= 0 ? y(t, m[e]) : m[e] - y(t, m[e]));
                }
                function O(e) {
                    return M(e, u);
                }
                function x(e) {
                    return M(e, l);
                }
                function j(e) {
                    return M(e, "minutes");
                }
                function D(e) {
                    return M(e, c);
                }
                function P(e) {
                    return M(e, "secondTenths");
                }
                function M(e, t) {
                    var n = L[t];
                    return k(t, X(e, h[t])), L[t] !== n;
                }
                function I() {
                    H(), W();
                }
                function H() {
                    clearInterval(e), (e = void 0), (q = !1), (A = !1);
                }
                function B(e) {
                    le() ? ((b = N()), (f = G(p.target))) : U(e), $();
                }
                function $() {
                    var t = h[n];
                    Y(z(Date.now())) || ((e = setInterval(R, t)), (q = !0), (A = !1));
                }
                function N() {
                    return z(Date.now()) - L.secondTenths * h.secondTenths * r;
                }
                function R() {
                    var e = z(Date.now());
                    V(F()), o(_.detail.timer), Y(e) && (te(), se("targetAchieved", _));
                }
                function F() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : z(Date.now()),
                        t = r > 0 ? e - b : b - e,
                        n = {};
                    return (n.secondTenths = P(t)), (n[c] = D(t)), (n.minutes = j(t)), (n[l] = x(t)), (n[u] = O(t)), n;
                }
                function z(e) {
                    return Math.floor(e / h[n]) * h[n];
                }
                function V(e) {
                    e.secondTenths && se("secondTenthsUpdated", _), e[c] && se("secondsUpdated", _), e.minutes && se("minutesUpdated", _), e[l] && se("hoursUpdated", _), e[u] && se("daysUpdated", _);
                }
                function Y(e) {
                    return f instanceof Array && e >= w;
                }
                function W() {
                    E.reset(), L.reset();
                }
                function U(e) {
                    (n = J((e = e || {}).precision)),
                        (o = "function" == typeof e.callback ? e.callback : function () {}),
                        (v = !0 === e.countdown),
                        (r = !0 === v ? -1 : 1),
                        "object" === t(e.startValues) ? Z(e.startValues) : (g = null),
                        (b = N()),
                        F(),
                        "object" === t(e.target) ? (f = G(e.target)) : v ? ((e.target = { seconds: 0 }), (f = G(e.target))) : (f = null),
                        (C = { precision: n, callback: o, countdown: "object" === t(e) && !0 === e.countdown, target: f, startValues: g }),
                        (p = e);
                }
                function J(e) {
                    if (!K((e = "string" == typeof e ? e : c))) throw new Error("Error in precision parameter: ".concat(e, " is not a valid value"));
                    return e;
                }
                function K(e) {
                    return d.indexOf(e) >= 0;
                }
                function Q(e) {
                    var n;
                    if ("object" === t(e))
                        if (e instanceof Array) {
                            if (5 !== e.length) throw new Error("Array size not valid");
                            n = e;
                        } else {
                            for (var r in e) if (d.indexOf(r) < 0) throw new Error("Error in startValues or target parameter: ".concat(r, " is not a valid input value"));
                            n = [e.secondTenths || 0, e.seconds || 0, e.minutes || 0, e.hours || 0, e.days || 0];
                        }
                    var i = n[0],
                        o = n[1] + X(i, 10),
                        a = n[2] + X(o, 60),
                        s = n[3] + X(a, 60),
                        c = n[4] + X(s, 24);
                    return (n[0] = i % 10), (n[1] = o % 60), (n[2] = a % 60), (n[3] = s % 24), (n[4] = c), n;
                }
                function X(e, t) {
                    var n = e / t;
                    return n < 0 ? Math.ceil(n) : Math.floor(n);
                }
                function G(e) {
                    if (e) {
                        var t = ee((f = Q(e)));
                        return (w = b + t.secondTenths * h.secondTenths * r), f;
                    }
                }
                function Z(e) {
                    (g = Q(e)), (E.secondTenths = g[0]), (E.seconds = g[1]), (E.minutes = g[2]), (E.hours = g[3]), (E.days = g[4]), (L = ee(g, L));
                }
                function ee(e, t) {
                    var n = t || {};
                    return (n.days = e[4]), (n.hours = 24 * n.days + e[3]), (n.minutes = 60 * n.hours + e[2]), (n.seconds = 60 * n.minutes + e[1]), (n.secondTenths = 10 * n.seconds + e[[0]]), n;
                }
                function te() {
                    I(), se("stopped", _);
                }
                function ne() {
                    I(), B(p), se("reset", _);
                }
                function re() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    (e = i(i({}, S), e)), ce() || (B(e), se("started", _));
                }
                function ie() {
                    H(), (A = !0), se("paused", _);
                }
                function oe(e, t) {
                    T.on(e, t);
                }
                function ae(e, t) {
                    T.removeListener(e, t);
                }
                function se(e, t) {
                    T.emit(e, t);
                }
                function ce() {
                    return q;
                }
                function le() {
                    return A;
                }
                function ue() {
                    return E;
                }
                function de() {
                    return L;
                }
                function he() {
                    return C;
                }
                U(S),
                    void 0 !== this &&
                        ((this.start = re),
                        (this.pause = ie),
                        (this.stop = te),
                        (this.reset = ne),
                        (this.isRunning = ce),
                        (this.isPaused = le),
                        (this.getTimeValues = ue),
                        (this.getTotalTimeValues = de),
                        (this.getConfig = he),
                        (this.addEventListener = oe),
                        (this.on = oe),
                        (this.removeEventListener = ae),
                        (this.off = ae));
            }
            (e.Timer = p), (e.default = p), Object.defineProperty(e, "__esModule", { value: !0 });
        })(t);
    },
    function (e, t, n) {
        var r, i, o;
        (i = []),
            (r = (function () {
                "use strict";
                var e = function (e) {
                    return e && "getComputedStyle" in window && "smooth" === window.getComputedStyle(e)["scroll-behavior"];
                };
                if ("undefined" == typeof window || !("document" in window)) return {};
                var t = function (t, n, r) {
                        var i;
                        (n = n || 999), r || 0 === r || (r = 9);
                        var o = function (e) {
                                i = e;
                            },
                            a = function () {
                                clearTimeout(i), o(0);
                            },
                            s = function (e) {
                                return Math.max(0, t.getTopOf(e) - r);
                            },
                            c = function (r, i, s) {
                                if ((a(), 0 === i || (i && i < 0) || e(t.body))) t.toY(r), s && s();
                                else {
                                    var c = t.getY(),
                                        l = Math.max(0, r) - c,
                                        u = new Date().getTime();
                                    (i = i || Math.min(Math.abs(l), n)),
                                        (function e() {
                                            o(
                                                setTimeout(function () {
                                                    var n = Math.min(1, (new Date().getTime() - u) / i),
                                                        r = Math.max(0, Math.floor(c + l * (n < 0.5 ? 2 * n * n : n * (4 - 2 * n) - 1)));
                                                    t.toY(r), n < 1 && t.getHeight() + r < t.body.scrollHeight ? e() : (setTimeout(a, 99), s && s());
                                                }, 9)
                                            );
                                        })();
                                }
                            },
                            l = function (e, t, n) {
                                c(s(e), t, n);
                            };
                        return {
                            setup: function (e, t) {
                                return (0 === e || e) && (n = e), (0 === t || t) && (r = t), { defaultDuration: n, edgeOffset: r };
                            },
                            to: l,
                            toY: c,
                            intoView: function (e, n, i) {
                                var o = e.getBoundingClientRect().height,
                                    a = t.getTopOf(e) + o,
                                    u = t.getHeight(),
                                    d = t.getY(),
                                    h = d + u;
                                s(e) < d || o + r > u ? l(e, n, i) : a + r > h ? c(a - u + r, n, i) : i && i();
                            },
                            center: function (e, n, r, i) {
                                c(Math.max(0, t.getTopOf(e) - t.getHeight() / 2 + (r || e.getBoundingClientRect().height / 2)), n, i);
                            },
                            stop: a,
                            moving: function () {
                                return !!i;
                            },
                            getY: t.getY,
                            getTopOf: t.getTopOf,
                        };
                    },
                    n = document.documentElement,
                    r = function () {
                        return window.scrollY || n.scrollTop;
                    },
                    i = t({
                        body: document.scrollingElement || document.body,
                        toY: function (e) {
                            window.scrollTo(0, e);
                        },
                        getY: r,
                        getHeight: function () {
                            return window.innerHeight || n.clientHeight;
                        },
                        getTopOf: function (e) {
                            return e.getBoundingClientRect().top + r() - n.offsetTop;
                        },
                    });
                if (
                    ((i.createScroller = function (e, r, i) {
                        return t(
                            {
                                body: e,
                                toY: function (t) {
                                    e.scrollTop = t;
                                },
                                getY: function () {
                                    return e.scrollTop;
                                },
                                getHeight: function () {
                                    return Math.min(e.clientHeight, window.innerHeight || n.clientHeight);
                                },
                                getTopOf: function (e) {
                                    return e.offsetTop;
                                },
                            },
                            r,
                            i
                        );
                    }),
                    "addEventListener" in window && !window.noZensmooth && !e(document.body))
                ) {
                    var o = "history" in window && "pushState" in history,
                        a = o && "scrollRestoration" in history;
                    a && (history.scrollRestoration = "auto"),
                        window.addEventListener(
                            "load",
                            function () {
                                a &&
                                    (setTimeout(function () {
                                        history.scrollRestoration = "manual";
                                    }, 9),
                                    window.addEventListener(
                                        "popstate",
                                        function (e) {
                                            e.state && "zenscrollY" in e.state && i.toY(e.state.zenscrollY);
                                        },
                                        !1
                                    )),
                                    window.location.hash &&
                                        setTimeout(function () {
                                            var e = i.setup().edgeOffset;
                                            if (e) {
                                                var t = document.getElementById(window.location.href.split("#")[1]);
                                                if (t) {
                                                    var n = Math.max(0, i.getTopOf(t) - e),
                                                        r = i.getY() - n;
                                                    0 <= r && r < 9 && window.scrollTo(0, n);
                                                }
                                            }
                                        }, 9);
                            },
                            !1
                        );
                    var s = new RegExp("(^|\\s)noZensmooth(\\s|$)");
                    window.addEventListener(
                        "click",
                        function (e) {
                            for (var t = e.target; t && "A" !== t.tagName; ) t = t.parentNode;
                            if (!(!t || 1 !== e.which || e.shiftKey || e.metaKey || e.ctrlKey || e.altKey)) {
                                if (a) {
                                    var n = history.state && "object" == typeof history.state ? history.state : {};
                                    n.zenscrollY = i.getY();
                                    try {
                                        history.replaceState(n, "");
                                    } catch (e) {}
                                }
                                var r = t.getAttribute("href") || "";
                                if (0 === r.indexOf("#") && !s.test(t.className)) {
                                    var c = 0,
                                        l = document.getElementById(r.substring(1));
                                    if ("#" !== r) {
                                        if (!l) return;
                                        c = i.getTopOf(l);
                                    }
                                    e.preventDefault();
                                    var u = function () {
                                            window.location = r;
                                        },
                                        d = i.setup().edgeOffset;
                                    d &&
                                        ((c = Math.max(0, c - d)),
                                        o &&
                                            (u = function () {
                                                history.pushState({}, "", r);
                                            })),
                                        i.toY(c, null, u);
                                }
                            }
                        },
                        !1
                    );
                }
                return i;
            })()),
            void 0 === (o = "function" == typeof r ? r.apply(t, i) : r) || (e.exports = o);
    },
    function (e, t, n) {
        "use strict";
        n.r(t);
        function r(e, t) {
            (this.container = (function (e) {
                if (!(e instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                if (null === e.getAttribute("data-section-id")) throw new Error("Theme Sections: The section container provided does not have an id assigned to the data-section-id attribute.");
                return e;
            })(e)),
                (this.id = e.getAttribute("data-section-id")),
                (this.extensions = []),
                Object.assign(
                    this,
                    (function (e) {
                        if ((void 0 !== e && "object" != typeof e) || null === e) throw new TypeError("Theme Sections: The properties object provided is not a valid");
                        return e;
                    })(t)
                ),
                this.onLoad();
        }
        (r.prototype = {
            onLoad: Function.prototype,
            onUnload: Function.prototype,
            onSelect: Function.prototype,
            onDeselect: Function.prototype,
            onBlockSelect: Function.prototype,
            onBlockDeselect: Function.prototype,
            extend: function (e) {
                this.extensions.push(e);
                var t = Object.assign({}, e);
                delete t.init, Object.assign(this, t), "function" == typeof e.init && e.init.apply(this);
            },
        }),
            "function" != typeof Object.assign &&
                Object.defineProperty(Object, "assign", {
                    value: function (e) {
                        if (null == e) throw new TypeError("Cannot convert undefined or null to object");
                        for (var t = Object(e), n = 1; n < arguments.length; n++) {
                            var r = arguments[n];
                            if (null != r) for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
                        }
                        return t;
                    },
                    writable: !0,
                    configurable: !0,
                });
        (window.Shopify = window.Shopify || {}), (window.Shopify.theme = window.Shopify.theme || {}), (window.Shopify.theme.sections = window.Shopify.theme.sections || {});
        var i = (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
            o = (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
        function a(e, t) {
            if ("string" != typeof e) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
            if (void 0 !== i[e]) throw new Error('Theme Sections: A section of type "' + e + '" has already been registered. You cannot register the same section type twice');
            function n(e) {
                r.call(this, e, t);
            }
            return (n.constructor = r), (n.prototype = Object.create(r.prototype)), (n.prototype.type = e), (i[e] = n);
        }
        function s(e, t) {
            (e = u(e)),
                void 0 === t && (t = document.querySelectorAll("[data-section-type]")),
                (t = d(t)),
                e.forEach(function (e) {
                    var n = i[e];
                    void 0 !== n &&
                        (t = t.filter(function (t) {
                            return !(c(t).length > 0) && null !== t.getAttribute("data-section-type") && (t.getAttribute("data-section-type") !== e || (o.push(new n(t)), !1));
                        }));
                });
        }
        function c(e) {
            var t = [];
            if (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e)) var n = e[0];
            if (e instanceof Element || n instanceof Element)
                d(e).forEach(function (e) {
                    t = t.concat(
                        o.filter(function (t) {
                            return t.container === e;
                        })
                    );
                });
            else if ("string" == typeof e || "string" == typeof n) {
                u(e).forEach(function (e) {
                    t = t.concat(
                        o.filter(function (t) {
                            return t.type === e;
                        })
                    );
                });
            }
            return t;
        }
        function l(e) {
            for (var t, n = 0; n < o.length; n++)
                if (o[n].id === e) {
                    t = o[n];
                    break;
                }
            return t;
        }
        function u(e) {
            return (
                "*" === e
                    ? (e = Object.keys(i))
                    : "string" == typeof e
                    ? (e = [e])
                    : e.constructor === r
                    ? (e = [e.prototype.type])
                    : Array.isArray(e) &&
                      e[0].constructor === r &&
                      (e = e.map(function (e) {
                          return e.prototype.type;
                      })),
                (e = e.map(function (e) {
                    return e.toLowerCase();
                }))
            );
        }
        function d(e) {
            return (
                NodeList.prototype.isPrototypeOf(e) && e.length > 0
                    ? (e = Array.prototype.slice.call(e))
                    : (NodeList.prototype.isPrototypeOf(e) && 0 === e.length) || null === e
                    ? (e = [])
                    : !Array.isArray(e) && e instanceof Element && (e = [e]),
                e
            );
        }
        window.Shopify.designMode &&
            (document.addEventListener("shopify:section:load", function (e) {
                var t = e.detail.sectionId,
                    n = e.target.querySelector('[data-section-id="' + t + '"]');
                null !== n && s(n.getAttribute("data-section-type"), n);
            }),
            document.addEventListener("shopify:section:unload", function (e) {
                var t = e.detail.sectionId,
                    n = e.target.querySelector('[data-section-id="' + t + '"]');
                "object" == typeof c(n)[0] &&
                    c(n).forEach(function (e) {
                        var t = o
                            .map(function (e) {
                                return e.id;
                            })
                            .indexOf(e.id);
                        o.splice(t, 1), e.onUnload();
                    });
            }),
            document.addEventListener("shopify:section:select", function (e) {
                var t = l(e.detail.sectionId);
                "object" == typeof t && t.onSelect(e);
            }),
            document.addEventListener("shopify:section:deselect", function (e) {
                var t = l(e.detail.sectionId);
                "object" == typeof t && t.onDeselect(e);
            }),
            document.addEventListener("shopify:block:select", function (e) {
                var t = l(e.detail.sectionId);
                "object" == typeof t && t.onBlockSelect(e);
            }),
            document.addEventListener("shopify:block:deselect", function (e) {
                var t = l(e.detail.sectionId);
                "object" == typeof t && t.onBlockDeselect(e);
            }));
        var h = window,
            m = (h.requestAnimationFrame || h.webkitRequestAnimationFrame || h.mozRequestAnimationFrame || h.msRequestAnimationFrame, window);
        m.cancelAnimationFrame || m.mozCancelAnimationFrame;
        document.documentElement;
        document.createElement("_");
        try {
            var y = Object.defineProperty({}, "passive", {
                get: function () {
                    !0;
                },
            });
            window.addEventListener("test", null, y);
        } catch (e) {}
        Object.keys ||
            (Object.keys = function (e) {
                var t = [];
                for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.push(n);
                return t;
            }),
            "remove" in Element.prototype ||
                (Element.prototype.remove = function () {
                    this.parentNode && this.parentNode.removeChild(this);
                });
        var p = n(0);
        function f() {
            this.entries = [];
        }
        function g(e, t) {
            v(e);
            var n = (function (e, t) {
                v(e),
                    (function (e) {
                        if (!Array.isArray(e)) throw new TypeError(e + " is not an array.");
                        if (0 === e.length) return [];
                        if (!e[0].hasOwnProperty("name")) throw new Error(e[0] + "does not contain name key.");
                        if ("string" != typeof e[0].name) throw new TypeError("Invalid value type passed for name of option " + e[0].name + ". Value should be string.");
                    })(t);
                var n = [];
                return (
                    t.forEach(function (t) {
                        for (var r = 0; r < e.options.length; r++)
                            if (e.options[r].name.toLowerCase() === t.name.toLowerCase()) {
                                n[r] = t.value;
                                break;
                            }
                    }),
                    n
                );
            })(e, t);
            return (function (e, t) {
                return (
                    v(e),
                    (function (e) {
                        if (Array.isArray(e) && "object" == typeof e[0]) throw new Error(e + "is not a valid array of options.");
                    })(t),
                    e.variants.filter(function (e) {
                        return t.every(function (t, n) {
                            return e.options[n] === t;
                        });
                    })[0] || null
                );
            })(e, n);
        }
        function v(e) {
            if ("object" != typeof e) throw new TypeError(e + " is not an object.");
            if (0 === Object.keys(e).length && e.constructor === Object) throw new Error(e + " is empty.");
        }
        (f.prototype.add = function (e, t, n) {
            this.entries.push({ element: e, event: t, fn: n }), e.addEventListener(t, n);
        }),
            (f.prototype.removeAll = function () {
                this.entries = this.entries.filter(function (e) {
                    return e.element.removeEventListener(e.event, e.fn), !1;
                });
            });
        var b = '[name="id"]',
            w = '[name^="options"]',
            S = '[name="quantity"]',
            E = '[name^="properties"]';
        function L(e, t, n) {
            (this.element = e),
                (this.product = (function (e) {
                    if ("object" != typeof e) throw new TypeError(e + " is not an object.");
                    if (void 0 === e.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                    return e;
                })(t)),
                (n = n || {}),
                (this._listeners = new f()),
                this._listeners.add(this.element, "submit", this._onSubmit.bind(this, n)),
                (this.optionInputs = this._initInputs(w, n.onOptionChange)),
                (this.quantityInputs = this._initInputs(S, n.onQuantityChange)),
                (this.propertyInputs = this._initInputs(E, n.onPropertyChange));
        }
        (L.prototype.destroy = function () {
            this._listeners.removeAll();
        }),
            (L.prototype.options = function () {
                return (
                    (e = this.optionInputs),
                    (t = function (e) {
                        return (e.name = /(?:^(options\[))(.*?)(?:\])/.exec(e.name)[2]), e;
                    }),
                    e.reduce(function (e, n) {
                        return (n.checked || ("radio" !== n.type && "checkbox" !== n.type)) && e.push(t({ name: n.name, value: n.value })), e;
                    }, [])
                );
                var e, t;
            }),
            (L.prototype.variant = function () {
                return g(this.product, this.options());
            }),
            (L.prototype.properties = function () {
                var e,
                    t,
                    n =
                        ((e = this.propertyInputs),
                        (t = function (e) {
                            return /(?:^(properties\[))(.*?)(?:\])/.exec(e)[2];
                        }),
                        e.reduce(function (e, n) {
                            return (n.checked || ("radio" !== n.type && "checkbox" !== n.type)) && (e[t(n.name)] = n.value), e;
                        }, {}));
                return 0 === Object.entries(n).length ? null : n;
            }),
            (L.prototype.quantity = function () {
                return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
            }),
            (L.prototype._setIdInputValue = function (e) {
                var t = this.element.querySelector(b);
                t || (((t = document.createElement("input")).type = "hidden"), (t.name = "id"), this.element.appendChild(t)), (t.value = e.toString());
            }),
            (L.prototype._onSubmit = function (e, t) {
                (t.dataset = this._getProductFormEventData()), t.dataset.variant && this._setIdInputValue(t.dataset.variant.id), e.onFormSubmit && e.onFormSubmit(t);
            }),
            (L.prototype._onFormEvent = function (e) {
                return void 0 === e
                    ? Function.prototype
                    : function (t) {
                          (t.dataset = this._getProductFormEventData()), e(t);
                      }.bind(this);
            }),
            (L.prototype._initInputs = function (e, t) {
                return Array.prototype.slice.call(this.element.querySelectorAll(e)).map(
                    function (e) {
                        return this._listeners.add(e, "change", this._onFormEvent(t)), e;
                    }.bind(this)
                );
            }),
            (L.prototype._getProductFormEventData = function () {
                return { options: this.options(), variant: this.variant(), properties: this.properties(), quantity: this.quantity() };
            });
        function T(e, t) {
            "string" == typeof e && (e = e.replace(".", ""));
            let n = "";
            const r = /\{\{\s*(\w+)\s*\}\}/,
                i = t || "${{amount}}";
            function o(e, t = 2, n = ",", r = ".") {
                if (isNaN(e) || null == e) return 0;
                const i = (e = (e / 100).toFixed(t)).split(".");
                return i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) + (i[1] ? r + i[1] : "");
            }
            switch (i.match(r)[1]) {
                case "amount":
                    n = o(e, 2);
                    break;
                case "amount_no_decimals":
                    n = o(e, 0);
                    break;
                case "amount_with_comma_separator":
                    n = o(e, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    n = o(e, 0, ".", ",");
            }
            return i.replace(r, n);
        }
        function q(e, t) {
            if (null === t) return e;
            if ("master" === t) return A(e);
            const n = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (n) {
                const r = e.split(n[0]),
                    i = n[0];
                return A(`${r[0]}_${t}${i}`);
            }
            return null;
        }
        function A(e) {
            return e.replace(/http(s)?:/, "");
        }
        function C() {
            return JSON.parse(JSON.stringify({ credentials: "same-origin", headers: { "X-Requested-With": "XMLHttpRequest", "Content-Type": "application/json;" } }));
        }
        function _(e, t) {
            return fetch(e, t).then(function (e) {
                if (!e.ok) throw e;
                return e.json();
            });
        }
        function k() {
            return _("/cart.js", C());
        }
        function O(e, t) {
            var n = C();
            return (t = t || {}), (n.method = "POST"), (n.body = JSON.stringify({ line: e, quantity: t.quantity, properties: t.properties })), _("/cart/change.js", n);
        }
        function x(e) {
            var t = C();
            return (t.method = "POST"), (t.body = JSON.stringify(e)), _("/cart/update.js", t);
        }
        function j(e) {
            if ("string" != typeof e || 2 !== e.split(":").length) throw new TypeError("Theme Cart: Provided key value is not a string with the format xxx:xxx");
        }
        function D(e) {
            if ("number" != typeof e || isNaN(e)) throw new TypeError("Theme Cart: Variant ID must be a number");
        }
        function P(e) {
            if ("object" != typeof e) throw new TypeError("Theme Cart: Options must be an object");
            if (void 0 === e.quantity && void 0 === e.properties) throw new Error("Theme Cart: You muse define a value for quantity or properties");
            void 0 !== e.quantity &&
                (function (e) {
                    if ("number" != typeof e || isNaN(e)) throw new TypeError("Theme Cart: An object which specifies a quantity or properties value is required");
                })(e.quantity),
                void 0 !== e.properties &&
                    (function (e) {
                        if ("object" != typeof e) throw new TypeError("Theme Cart: Properties must be an object");
                    })(e.properties);
        }
        function M(e) {
            return (
                j(e),
                k().then(function (t) {
                    var n = -1;
                    return (
                        t.items.forEach(function (t, r) {
                            n = t.key === e ? r + 1 : n;
                        }),
                        -1 === n ? Promise.reject(new Error("Theme Cart: Unable to match line item with provided key")) : n
                    );
                })
            );
        }
        function I(e) {
            !(function (e) {
                if (!(e instanceof HTMLFormElement)) throw new TypeError("Theme Cart: Form must be an instance of HTMLFormElement");
            })(e);
            var t = new FormData(e);
            return (
                D(parseInt(t.get("id"), 10)),
                (function (e) {
                    var t = C();
                    return delete t.headers["Content-Type"], (t.method = "POST"), (t.body = e), _("/cart/add.js", t);
                })(t)
            );
        }
        function H(e) {
            return (
                j(e),
                M(e).then(function (e) {
                    return O(e, { quantity: 0 });
                })
            );
        }
        function B() {
            return ((e = C()).method = "POST"), _("/cart/clear.js", e);
            var e;
        }
        function $(e) {
            return x({ attributes: e });
        }
        var N = n(1),
            R = n.n(N),
            F = {
                addEvent: function (e, t, n, r) {
                    e.addEventListener(
                        t,
                        function (e) {
                            e.target.matches(n + ", " + n + " *") && r.apply(e.target.closest(n), arguments);
                        },
                        !1
                    );
                },
                forEach: function (e, t, n) {
                    let r = e.querySelectorAll(t);
                    r.length &&
                        r.forEach(function (e) {
                            n.apply(r, arguments);
                        });
                },
                debounceTime: function (e, t) {
                    var n;
                    return function () {
                        var r = this,
                            i = arguments,
                            o = function () {
                                t.apply(r, i);
                            };
                        clearTimeout(n), (n = setTimeout(o, e));
                    };
                },
                detectDeviceType: () => (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? "Mobile" : "Desktop"),
                escape: (e) =>
                    e.replace(/[<>\&\"\']/g, function (e) {
                        return "&#" + e.charCodeAt(0) + ";";
                    }),
                fadeIn: function (e, t = 400) {
                    if (e)
                        if (((e.style.opacity = 0), (e.style.filter = "alpha(opacity=0)"), (e.style.display = "inline-block"), (e.style.visibility = "visible"), t))
                            var n = 0,
                                r = setInterval(function () {
                                    (n += 50 / t) >= 1 && (clearInterval(r), (n = 1)), (e.style.opacity = n), (e.style.filter = "alpha(opacity=" + 100 * n + ")");
                                }, 50);
                        else (e.style.opacity = 1), (e.style.filter = "alpha(opacity=1)");
                },
                fadeOut: function (e, t = 400) {
                    if (e)
                        if (t)
                            var n = 1,
                                r = setInterval(function () {
                                    (n -= 50 / t) <= 0 && (clearInterval(r), (n = 0), (e.style.display = "none"), (e.style.visibility = "hidden")), (e.style.opacity = n), (e.style.filter = "alpha(opacity=" + 100 * n + ")");
                                }, 50);
                        else (e.style.opacity = 0), (e.style.filter = "alpha(opacity=0)"), (e.style.display = "none"), (e.style.visibility = "hidden");
                },
                getCookie: (e) => {
                    let t,
                        n = document.cookie,
                        r = e + "=",
                        i = n.indexOf("; " + r);
                    if (-1 == i) {
                        if (((i = n.indexOf(r)), 0 != i)) return null;
                    } else (i += 2), (t = document.cookie.indexOf(";", i)), -1 == t && (t = n.length);
                    return decodeURI(n.substring(i + r.length, t));
                },
                getWidthBrowser: function () {
                    let e;
                    return (
                        "number" == typeof window.innerWidth
                            ? (e = window.innerWidth)
                            : document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)
                            ? (e = document.documentElement.clientWidth)
                            : document.body && (document.body.clientWidth || document.body.clientHeight) && (e = document.body.clientWidth),
                        e
                    );
                },
                getHeightBrowser: function () {
                    let e;
                    return (
                        "number" == typeof window.innerHeight
                            ? (e = window.innerHeight)
                            : document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)
                            ? (e = document.documentElement.clientHeight)
                            : document.body && (document.body.clientWidth || document.body.clientHeight) && (e = document.body.clientHeight),
                        e
                    );
                },
                handle: (e) =>
                    e
                        .toLowerCase()
                        .replace(/[^\w\s.\//]/gi, "")
                        .trim()
                        .replace(/[\s.\//]/g, "-"),
                isExist: (e) => null != e && void 0 !== e,
                scrollBarWidth: function () {
                    let { left: e, right: t } = document.body.getBoundingClientRect();
                    return e + t < window.innerWidth ? window.innerWidth - (e + t) : 0;
                },
                scrollTo: function (e) {
                    let t = "string" == typeof e ? document.querySelector(e) : e;
                    if (null == t) return;
                    t.getBoundingClientRect().top, null != window.pageYOffset ? window.pageYOffset : window.scrollTop;
                    R.a.center(t, 1e3);
                },
                removeSquareBracket: (e) => e.replace(/\[|\]/g, ""),
                activeLazyload: (e, t) =>
                    new Promise((n, r) => {
                        e.addEventListener("lazyincludeloaded", (e) => {
                            t(e), n(!0);
                        });
                    }),
            },
            z = {
                currenciesCallback: function () {
                    if ("2" != theme.currency.type) return;
                    var e = "",
                        t = "",
                        n = "";
                    let r = this;
                    (theme.currency.currenciesCallback = () => {
                        if (null == Currency || null == theme.currency) return;
                        (Currency.format = theme.currency.currency_format), (e = theme.currency.shopCurrency);
                        let i = document.querySelector('select[name="currency"]');
                        i.value != e && ((i.value = e), i.dispatchEvent(new Event("change")), i.closest("form").submit()),
                            (Currency.money_with_currency_format[e] = theme.currency.moneyFormatWithCurrency_strip),
                            (Currency.money_format[e] = theme.currency.moneyFormat_strip),
                            (t = e),
                            (n = Currency.cookie.read());
                        let o = document.querySelectorAll("span.money");
                        o.length &&
                            o.forEach((t) => {
                                t.setAttribute("data-currency-" + e, t.innerHTML);
                            }),
                            null == n
                                ? (e !== t ? Currency.convertAll(e, t) : (Currency.currentCurrency = t), Currency.cookie.write(t))
                                : n === e
                                ? (Currency.currentCurrency = e)
                                : (void 0 === n && (n = t), Currency.convertAll(e, n), Currency.convertAll(Currency.currentCurrency, n)),
                            r.updateState();
                    }),
                        (theme.currency.currenciesCallbackSpecial = (t) => {
                            if ("undefined" == typeof Currency || void 0 === theme.currency) return;
                            let n = document.querySelectorAll(t);
                            n.length &&
                                n.forEach((t) => {
                                    t.setAttribute("data-currency-" + e, t.innerHTML);
                                }),
                                Currency.convertAll(e, Currency.cookie.read(), t, theme.currency.currency_format);
                        });
                },
                convert: function (e) {
                    "2" == theme.currency.type && theme.currency && theme.currency.currenciesCallbackSpecial && theme.currency.currenciesCallbackSpecial(e);
                },
                updateState: function () {
                    if ("2" != theme.currency.type) return;
                    let e = F.getCookie("currency"),
                        t = document.querySelectorAll("[data-currency-code]"),
                        n = document.querySelectorAll(".btn-currency[data-value]");
                    e.includes(";") && (e = e.split(";")[0]),
                        t.length &&
                            t.forEach((t) => {
                                t.textContent = e;
                            }),
                        n.length &&
                            n.forEach((t) => {
                                t.getAttribute("data-value") == e ? t.classList.add("active") : t.classList.remove("active");
                            });
                },
                initEvents: function () {
                    let e = this;
                    F.addEvent(document, "click", ".btn-currency", (t) => {
                        t.preventDefault();
                        let n = t.target.getAttribute("data-value");
                        switch (theme.currency.type) {
                            case "1":
                                let t = document.querySelector("form.shopify-currency-form");
                                if (null == t) return;
                                let r = t.querySelector("select");
                                (r.value = n), r.dispatchEvent(new Event("change")), t.submit();
                                break;
                            case "2":
                                "undefined" != typeof Currency && Currency.convertAll(Currency.currentCurrency, n), e.updateState();
                        }
                    }),
                        "2" == theme.currency.type && theme.currency.currenciesCallback();
                },
                init: function () {
                    if (!theme.currency.enable) return;
                    this.currenciesCallback(), this.initEvents();
                },
            },
            V = 0,
            Y = "#dialogNotify";
        null != EventTarget.prototype.addEventListener1 && (EventTarget.prototype.addEventListener = EventTarget.prototype.addEventListener1);
        var W = {
                onClick: function (e, t, n = document) {
                    let r = n.querySelectorAll(e);
                    r.length &&
                        r.forEach(function (e, n) {
                            e.addEventListener("click", t);
                        });
                },
                isExist: (e) => null != e && void 0 !== e,
                initDialog: () => {
                    F.addEvent(document, "click", "[data-dialog-trigger]", async (e) => {
                        e.preventDefault();
                        let t = e.target.getAttribute("data-dialog-trigger"),
                            n = t.toLowerCase(),
                            r = document.querySelector(t);
                        F.isExist(r) &&
                            (document.body.classList.add("lazy-loading"),
                            F.isExist(r.querySelector(":scope > .lazyload[data-include]")) &&
                                (r.classList.add("lazy-active"),
                                await F.activeLazyload(r, (e) => {
                                    r.classList.remove("lazy-active");
                                })),
                            W.disablePageScroll(!0),
                            document.body.classList.remove("lazy-loading"),
                            r.classList.toggle("is-open"),
                            n.includes("menumobile") && document.body.classList.toggle("menuMobile-is-active"),
                            r.classList.contains("is-open") &&
                                (z.convert(t + " .money"), (n.includes("currency") || n.includes("menumobile")) && z.updateState(), t.toLowerCase().includes("search") && r.querySelector('input[name="q"]').focus()));
                    }),
                        F.addEvent(document, "click", "[data-dialog-close]", (e) => {
                            let t = e.target.closest("dialog");
                            F.isExist(t) && (e.preventDefault(), t.classList.remove("is-open"), "menuMobile" == t.getAttribute("id") && document.body.classList.remove("menuMobile-is-active"), W.disablePageScroll(!1));
                        });
                },
                triggerDialog(e, t = "show") {
                    let n = document.getElementById(e.replace(/^\W/g, ""));
                    if (null != n) {
                        if ("show" == t)
                            return (
                                document.querySelectorAll("dialog.is-open").length &&
                                    document.querySelectorAll("dialog.is-open").forEach((e) => {
                                        e.classList.remove("is-open");
                                    }),
                                document.body.classList.contains("menuMobile-is-active") && document.body.classList.remove("menuMobile-is-active"),
                                n.classList.add("is-open"),
                                void W.disablePageScroll(!0)
                            );
                        n.classList.remove("is-open"), W.disablePageScroll(!1);
                    }
                },
                tabPanel_init: (e = null) => {
                    let t = e || document,
                        n = t.querySelectorAll(".featured_group_tab-ui .featured_group_tab-link a");
                    n.length &&
                        n.forEach((e) => {
                            e.addEventListener("click", (e) => {
                                e.preventDefault();
                                let n = e.currentTarget,
                                    r = t.querySelector(n.getAttribute("href"));
                                !n.closest(".featured_group_tab-link").classList.contains("active") &&
                                    F.isExist(r) &&
                                    (r
                                        .closest(".featured_group_tab-ui")
                                        .querySelectorAll(".featured_group_tab-pane.active, .featured_group_tab-link.active")
                                        .forEach((e, t) => {
                                            e.classList.remove("active");
                                        }),
                                    n.closest(".featured_group_tab-link").classList.add("active"),
                                    r.classList.add("active"));
                            });
                        });
                },
                initSlider: function (e) {
                    let t = this,
                        n = e,
                        r = n.querySelector('input[name="sectionSlideConfig"]'),
                        i = n.querySelectorAll(".slide_ui-element");
                    if (!F.isExist(i) || !F.isExist(r) || null == theme.slider) return;
                    let o = !!r.getAttribute("data-nav") && JSON.parse(r.getAttribute("data-nav")),
                        a = !!r.getAttribute("data-dot") && JSON.parse(r.getAttribute("data-dot")),
                        s = !!r.getAttribute("data-loop") && JSON.parse(r.getAttribute("data-loop")),
                        c = (!!r.getAttribute("data-auto-width") && JSON.parse(r.getAttribute("data-auto-width")), r.getAttribute("data-items").split(",")),
                        l = r.getAttribute("data-gutters") || "",
                        u = r.getAttribute("data-item-class");
                    l = l.replace(/[^\d.,]/g, "").split(",");
                    let d = n.getAttribute("data-section-type") || "";
                    i.forEach((e, r) => {
                        let i = e.closest("div[data-slide-wrapper]") || n;
                        e.classList.remove("row", "d-grid");
                        let h = {
                            0: { items: +c[5] || +c[0], gutter: +l[5] || +l[0], center: !1 },
                            375: { items: +c[4] || +c[0], gutter: +l[4] || +l[0], center: !1 },
                            576: { items: +c[3] || +c[0], gutter: +l[3] || +l[0], center: !1 },
                            768: { items: +c[2] || +c[0], gutter: +l[2] || +l[0], center: !1 },
                            992: { items: +c[1] || +c[0], gutter: +l[1] || +l[0], center: !1 },
                            1200: { items: +c[0] || +c[0], gutter: +l[0] || +l[0], center: !1 },
                        };
                        if ("" != u) for (r = 0; r < e.children.length; r++) e.children[r].className = u;
                        let m = {
                                container: e,
                                items: c[5],
                                gutter: l[5],
                                slideBy: "page",
                                startIndex: 0,
                                loop: s,
                                speed: 300,
                                edgePadding: 0,
                                mouseDrag: !0,
                                swipeAngle: 30,
                                autoplayButtonOutput: !1,
                                autoplay: !1,
                                autoplayTimeout: 5e3,
                                animateIn: "tns-fadeIn",
                                animateOut: "tns-fadeOut",
                                controls: o,
                                controlsPosition: "bottom",
                                controlsContainer: i.querySelector(".slide_ui-controls--nav"),
                                nav: a,
                                navPosition: "bottom",
                                responsive: h,
                                preventActionWhenRunning: !1,
                                preventScrollOnTouch: !1,
                                onInit: () => {
                                    F.isExist(n.querySelector(".tns-nav")) && n.querySelector(".tns-nav").classList.add("slide_ui-controls", "slide_ui-controls--dot"),
                                        d.includes("product") &&
                                            (e.querySelector(".tns-slide-active").classList.add("tns-first"), e.querySelectorAll(".tns-slide-active")[e.querySelectorAll(".tns-slide-active").length - 1].classList.add("tns-last")),
                                        null != n.closest(".layout-full-right") && t.handleTestimonial(n, "resize");
                                },
                            },
                            y = theme.slider(m);
                        d.includes("product") &&
                            y.events.on("indexChanged", (t, n) => {
                                e.querySelectorAll(".tns-first, .tns-last").forEach((e) => {
                                    e.classList.remove("tns-first", "tns-last");
                                }),
                                    e.querySelector(".tns-slide-active").classList.add("tns-first"),
                                    e.querySelectorAll(".tns-slide-active")[e.querySelectorAll(".tns-slide-active").length - 1].classList.add("tns-last");
                            });
                    });
                },
                handleTestimonial: function (e, t = null) {
                    let n = this,
                        r = e.querySelector(".calc-container"),
                        i = (e.querySelector(".tns-slider"), e.querySelector(".tns-outer")),
                        o = (e.clientWidth - r.clientWidth) / 2;
                    (i.style.cssText = `padding-left: ${o}px !important`),
                        null != t &&
                            window.addEventListener("resize", function (t) {
                                n.handleTestimonial(e);
                            });
                },
                escape: (e) =>
                    e.replace(/[<>\&\"\']/g, function (e) {
                        return "&#" + e.charCodeAt(0) + ";";
                    }),
                handle: (e) =>
                    e
                        .toLowerCase()
                        .replace(/[^\w\s.\//]/gi, "")
                        .trim()
                        .replace(/[\s.\//]/g, "-"),
                removeSquareBracket: (e) => e.replace(/\[|\]/g, ""),
                setCookie: (e, t, n) => {
                    let r = new Date();
                    r.setTime(r.getTime() + 24 * n * 60 * 60 * 1e3);
                    let i = "expires=" + r.toUTCString();
                    document.cookie = `${e}=${t}; ${i}; path=/`;
                },
                getCookie: (e) => {
                    let t,
                        n = document.cookie,
                        r = e + "=",
                        i = n.indexOf("; " + r);
                    if (-1 == i) {
                        if (((i = n.indexOf(r)), 0 != i)) return null;
                    } else (i += 2), (t = document.cookie.indexOf(";", i)), -1 == t && (t = n.length);
                    return decodeURI(n.substring(i + r.length, t));
                },
                clickModal: function (e) {
                    F.addEvent(document, "click", e, async (e) => {
                        e.preventDefault();
                        let t = e.target.getAttribute("data-target") || "",
                            n = document.querySelector(t);
                        "" != t && F.isExist(n) && (n.classList.contains("active") ? (n.classList.remove("active"), W.disablePageScroll(!1)) : (n.classList.add("active"), W.disablePageScroll(!0)));
                    });
                },
                disablePageScroll: function (e, t = null) {
                    let n = [];
                    n.push("modal-opened"), null != t && n.push(t);
                    let r = F.scrollBarWidth();
                    if (e) return document.body.style.setProperty("padding-right", r + "px"), void document.body.classList.add(...n);
                    document.body.style.removeProperty("padding-right"), document.body.classList.remove(...n);
                },
                ajaxCall: (e, t, n, r, i) => {
                    if (!window.XMLHttpRequest) return null;
                    var o = new XMLHttpRequest();
                    return (
                        (n = n || "GET"),
                        (r = r || null),
                        (i = i || "text/plain"),
                        o.open(n, e),
                        o.setRequestHeader("Content-Type", i),
                        (o.onreadystatechange = function () {
                            4 === o.readyState && (200 === o.status ? t(o.responseText) : console.log(o));
                        }),
                        o.send(r),
                        o
                    );
                },
                recordRecentView: function (e) {
                    let t = W.getCookie("recentViewItem");
                    null != t && (e += "|" + t), (t = [...new Set(e.split("|"))].join("|")), W.setCookie("recentViewItem", t);
                },
                recentView: async function () {
                    let e = this,
                        t = +theme.product.recent_total,
                        n = W.getCookie("recentViewItem"),
                        r = document.querySelector("#recentlyView"),
                        i = theme.productSettings ? theme.productSettings.handle : "";
                    if (null == n || !F.isExist(r)) return;
                    let o = [...new Set(n.split("|"))];
                    o.length > t && (o = o.slice(0, t + 1)), W.setCookie("recentViewItem", o.join("|"));
                    let a = o.map(async (e) => {
                            let t = await fetch(`/products/${e}.js`);
                            return t.ok ? t.json() : "";
                        }),
                        s = await Promise.all(a);
                    if (((s.length > 1 || (1 == s.length && s.some((e) => e.handle != i))) && (r.style.display = "block"), "block" != r.style.display)) return;
                    let c = [];
                    s.forEach(async (t, n) => {
                        t.handle && t.handle != i && (await c.push(e.renderItem(t, "[data-recent-container]")));
                    });
                    await Promise.all(c);
                    W.initSlider(r), z.convert("#recentlyView .money");
                },
                renderItem: async (e, t) => {
                    let n = "#productCardLayout",
                        r = "[data-item-image]",
                        i = "[data-item-url]",
                        o = "[data-item-title]",
						boldOptions= "[bold-options]",
                        a = "[data-item-price]",
                        s = "[data-item-price-compare]",
                        c = document.querySelector(t),
                        l = document.querySelector(n) || W.renderSelector;

                    if (null == c) return;
                    if (null == l) {
                        let e = new Promise((e, t) => {
                                fetch(theme.routes.search_url + "?view=include.product-item").then((t) => {
                                    t.text().then((t) => {
                                        e(t);
                                    });
                                });
                            }),
                            t = await e;
                        l = new DOMParser().parseFromString(t, "text/html").querySelector(n);
                    }
                    e.variants[0];
                    l.querySelectorAll(i).forEach((t) => {
                        t.setAttribute("href", e.url);
                    }),
                        (l.querySelector(o).innerHTML = e.title),
						// (l.querySelector(boldOptions).innerHTML = '<div class="bold_load_cart_item_properties"></div>'),
                        (l.querySelector(a).innerHTML = T(e.price, theme.currency.moneyFormat)),
                        (l.querySelector(s).innerHTML = T(e.compare_at_price, theme.currency.moneyFormat));

                    let u = e.featured_image || theme.product.default_image;
                    l.querySelector(r).setAttribute("data-src", q(u, "280x")),
                        l.querySelector(r).setAttribute("alt", e.title),
                        l.querySelector(r).classList.add("lazyload"),
                        null == e.compare_at_price ? l.querySelector(s).classList.add("hide") : l.querySelector(s).classList.remove("hide");
                    let d = l.innerHTML;
                    return "[data-recent-container]" == t && (d = `<div class="product-section">${d}</div>`), c.insertAdjacentHTML("beforeend", d), !0;
                                  
                },
                getItems: async (e, t = 0) => {
                    if (t >= e.length) return;
                    let n = await fetch(`/products/${e[t]}.js`);
                    return await n.json();
                },
                moneyFormat: (e) => T(e, theme.currency.moneyFormat),
                changePrice: (e, t, n) => {
                    let r = t.querySelector(n.price) || {},
                        i = t.querySelector(n.price_sale) || {},
                        o = t.querySelector(n.price_compare) || {},
                        a = t.querySelector(n.soldout) || {};
                    r.classList.add("hide"),
                        i.classList.add("hide"),
                        o.classList.add("hide"),
                        a.classList.add("hide"),
                        null !== e && e.available
                            ? (e.available &&
                                  (a.classList.add("hide"),
                                  null != e.compare_at_price && e.compare_at_price > e.price
                                      ? ((i.innerHTML = T(e.price, theme.currency.moneyFormat)), (o.innerHTML = T(e.compare_at_price, theme.currency.moneyFormat)), i.classList.remove("hide"), o.classList.remove("hide"))
                                      : ((r.innerHTML = T(e.price, theme.currency.moneyFormat)), r.classList.remove("hide"))),
                              console.log(theme))
                            : a.classList.remove("hide");
                },
                easyTimer_HTML: function (e, t) {
                    if (t > 9) {
                        let n = t.toString().split("");
                        n.forEach((t, r) => {
                            let i = e.querySelector(`.date-value[data-index="${r + 1}"]`);
                            if (F.isExist(i)) i.innerHTML = n[r];
                            else {
                                let t = e.querySelector(`.date-value[data-index="${r}"]`),
                                    i = t.outerHTML.replace(`data-index="${r}"`, `data-index="${r + 1}"`).replace(t.innerHTML + "</span>", n[r] + "</span");
                                e.querySelector(`.date-value[data-index="${r}"]`).insertAdjacentHTML("afterend", i);
                            }
                        });
                    } else (e.querySelector('.date-value[data-index="1"]').innerHTML = 0), (e.querySelector('.date-value[data-index="2"]').innerHTML = t);
                },
                initSwatch: (e = document) => {
                    let t = e.querySelectorAll('[data-swatch-wrapper] input[type="radio"]');
                    t.length &&
                        t.forEach((e) => {
                            e.addEventListener("change", (t) => {
                                let n = e.value,
                                    r = document.querySelector(e.closest(".swatch-option").getAttribute("data-target"));
                                (r.value = n), r.dispatchEvent(new Event("change"));
                            });
                        });
                },
                init_EasyTimer: function (e, t) {
                    let n = new p.Timer();
                    n.start({ countdown: !0, startValues: { seconds: t } }),
                        n.addEventListener("secondsUpdated", function (t) {
                            let r = n.getTimeValues().days,
                                i = n.getTimeValues().hours,
                                o = n.getTimeValues().minutes,
                                a = n.getTimeValues().seconds,
                                s = 24 * r + i;
                            if (
                                (s > 99 ? W.easyTimer_HTML(e.querySelector(".count-day"), r) : e.querySelector(".count-day").classList.add("hide"),
                                W.easyTimer_HTML(e.querySelector(".count-hrs"), s > 99 ? i : s),
                                W.easyTimer_HTML(e.querySelector(".count-min"), o),
                                W.easyTimer_HTML(e.querySelector(".count-sec"), a),
                                !JSON.parse(e.getAttribute("data-hide-label")))
                            ) {
                                let t = r > 1 ? theme.dateLabel.days : theme.dateLabel.day,
                                    n = i > 1 ? theme.dateLabel.hours : theme.dateLabel.hour,
                                    s = o > 1 ? theme.dateLabel.minutes : theme.dateLabel.minute,
                                    c = a > 1 ? theme.dateLabel.seconds : theme.dateLabel.second;
                                (e.querySelector(".count-day .date-label").innerHTML = t),
                                    (e.querySelector(".count-hrs .date-label").innerHTML = n),
                                    (e.querySelector(".count-min .date-label").innerHTML = s),
                                    (e.querySelector(".count-sec .date-label").innerHTML = c);
                            }
                            e.classList.add("countdown-loaded");
                        }),
                        n.addEventListener("targetAchieved", function (t) {
                            e.classList.add("hide");
                        });
                },
                initCountdown: function (e = null) {
                    let t = e;
                    null == t && (t = document);
                    let n = t.querySelectorAll(".countdown-time:not(.countdown-loaded)");
                    n.length &&
                        n.forEach((e) => {
                            if (!e.classList.contains("countdown-loaded")) {
                                let t = e,
                                    n = t.getAttribute("data-date").split("/"),
                                    r = new Date(n[2], Number(n[0]) - 1, n[1]).getTime() / 1e3,
                                    i = new Date().getTime() / 1e3,
                                    o = r > i ? r - i : 0;
                                o > 0 ? W.init_EasyTimer(t, o) : t.remove();
                            }
                        });
                },
                initCountryProvinceSelector: () => {
                    let e = document.querySelectorAll(".customer_address_table[data-id]");
                    e.length &&
                        (new Shopify.CountryProvinceSelector("address_country_new", "address_province_new", { hideElement: "address_province_container_new" }),
                        e.forEach((e) => {
                            let t = e.getAttribute("data-id"),
                                n = "address_country_" + t,
                                r = "address_province_" + t,
                                i = "address_province_container_" + t;
                            new Shopify.CountryProvinceSelector(n, r, { hideElement: i });
                        }));
                },
                initVideo: function (e) {
                    let t = e.querySelectorAll("[data-button-video]");
                    t.length &&
                        t.forEach((e) => {
                            e.addEventListener("click", (e) => {
                                e.preventDefault();
                                let t = e.currentTarget.closest("[data-video-container]"),
                                    n = t.querySelector("video");
                                t.classList.contains("video-playing") ? (t.classList.remove("video-playing"), F.isExist(n) && n.pause()) : (t.classList.add("video-playing"), F.isExist(n) && n.play());
                            });
                        });
                },
                scrollToTop: function () {
                    let e = document.documentElement.scrollTop || document.body.scrollTop;
                    e > 0 && (window.requestAnimationFrame(W.scrollToTop), window.scrollTo(0, e - e / 8));
                },
                resetCollectionPagination: () => {
                    null != theme.collectionPagination && $({ pagination: null });
                },
                fixReview: function () {
                    let e = document.querySelectorAll(".featured_product__item-review:not(.loaded)");
                    e.length &&
                        e.forEach((e) => {
                            e.addEventListener("lazyincludeloaded", (e) => {
                                "shopify" == theme.product.review_type && "undefined" != typeof SPR && (SPR.initDomEls(), window.loadBadges.call(SPR));
                            });
                        });
                },
                showNotify: async function (e) {
                    let t = document.querySelector(Y);
                    if (null == t) {
                        let e = await fetch(theme.routes.search_url + "?view=dialog.notification"),
                            n = await e.text();
                        document.body.insertAdjacentHTML("beforeend", n), (t = document.querySelector(Y));
                    }
                    (t = t.querySelector("[data-notify-content]")), (t.innerHTML = e || theme.cart.error_add_cart), W.triggerDialog(Y);
                },
                subscribeForm: function () {
                    let e = this;
                    (e.subscribeFail = () => {
                        W.showNotify("Could not connect to the registration server. Please try again later.");
                    }),
                        (e.ajaxMailchimp = (t) => {
                            let n = t.getAttribute("action"),
                                r = t.querySelector('input[type="email"]'),
                                i = "&EMAIL=" + encodeURIComponent(r.value);
                            if ("" == n) return void e.subscribeFail();
                            let o = document.createElement("script");
                            (o.src = n + i), document.body.appendChild(o);
                            window.mailchimpCallback = function (n) {
                                delete window.mailchimpCallback, document.body.removeChild(o), "success" == n.result ? ((r.value = ""), W.showNotify(t.querySelector(".thank_you").innerText || n.msg)) : e.subscribeFail();
                            };
                        });
                    let t = [...document.querySelectorAll("form.form-subscribe")];
                    t.length &&
                        t.map((t) => {
                            let n = t.getAttribute("data-form-type");
                            t.addEventListener("submit", (r) => {
                                let i = t.getAttribute("action");
                                if (("mailchimp" == n && (r.preventDefault(), e.ajaxMailchimp(t)), "klaviyo" == n && ("" == i || "undefined" == typeof KlaviyoSubscribe))) return r.preventDefault(), void e.subscribeFail();
                            }),
                                "klaviyo" == n &&
                                    "undefined" != typeof KlaviyoSubscribe &&
                                    KlaviyoSubscribe.attachToForms(t, {
                                        custom_success_message: !0,
                                        success: function (e) {
                                            e.find('input[type="email"]').val(""), W.showNotify(e.find(".thank_you").text());
                                        },
                                    });
                        });
                },
                initEvents: function () {
                    let e = this;
                    e.fixReview(),
                        e.initDialog(),
                        e.subscribeForm(),
                        e.clickModal("a[data-target]"),
                        (Shopify.moneyFormat = function (e, t) {
                            return T(e, t);
                        }),
                        document.body.addEventListener(
                            "click",
                            function (e) {
                                let t = e.target;
                                document.body.classList.contains("modal-opened") &&
                                    ((null != t.closest(".ssw-login") && null == t.closest(".ssw-modal-content")) || t.classList.contains("ssw-close")) &&
                                    document.body.classList.remove("modal-opened");
                            },
                            !0
                        ),
                        F.addEvent(
                            document,
                            "click",
                            ".sb-btn-show",
                            (e) => {
                                e.preventDefault();
                                let t = e.target.getAttribute("data-target"),
                                    n = document.querySelector(t) || null;
                                null != n && (n.classList.add("active"), W.disablePageScroll(!0));
                            },
                            !1
                        ),
                        F.addEvent(
                            document,
                            "click",
                            ".sb-btn-close",
                            (e) => {
                                e.preventDefault();
                                let t = e.target.getAttribute("data-target"),
                                    n = document.querySelector(t) || null;
                                null != n && (n.classList.remove("active"), W.disablePageScroll(!1));
                            },
                            !1
                        );
                    let t = document.querySelector("#backToTop");
                    F.isExist(t) &&
                        (t.addEventListener("click", (e) => {
                            e.preventDefault(), W.scrollToTop();
                        }),
                        window.addEventListener(
                            "scroll",
                            (e) => {
                                let n = window.scrollY;
                                n > 100 && n + window.innerHeight < document.body.clientHeight - 100 ? t.classList.add("active") : t.classList.remove("active");
                            },
                            { passive: !1 }
                        )),
                        void 0 !== Storage &&
                            (document.body.classList.contains("templateCollection") && (sessionStorage.collection = theme.collectionLink),
                            null != document.querySelector("#continueShopping") && void 0 !== sessionStorage.collection && (document.querySelector("#continueShopping").href = sessionStorage.collection)),
                        F.addEvent(document, "click", ".btn-language", (e) => {
                            e.preventDefault();
                            let t = e.target,
                                n = t.getAttribute("data-lang"),
                                r = t.closest("dialog").getAttribute("data-return"),
                                i = location.origin + n + r;
                            window.location.href = i;
                        }),
                        window.addEventListener("scroll", (e) => {
                            document.querySelectorAll(".lazyqueue-wait").forEach((e, t) => {
                                e.classList.add("lazyqueue-active");
                            });
                        }),
                        document.body.addEventListener("lazyincludeloaded", (e) => {
                            null != e.target.closest(".lazyqueue-wait") && e.target.closest(".lazyqueue-wait").classList.remove("lazyqueue-active", "lazyqueue-wait");
                        }),
                        window.addEventListener("load", () => {
                            if ((e.recentView(), window.location.href.includes("shopifypreview"))) {
                                let e = document.querySelector("#preview-bar-iframe");
                                F.isExist(e) && (e.style.display = "none"),
                                    F.debounceTime(1e3, () => {
                                        document.body.closest("html").style.paddingBottom = null;
                                    })();
                            }
                            if (F.getWidthBrowser() < 768) {
                                let e = document.querySelector("#admin-bar-iframe");
                                F.isExist(e) && (e.style.display = "none"),
                                    F.debounceTime(1e3, () => {
                                        document.body.closest("html").style.paddingBottom = null;
                                    })();
                            }
                        }),
                        window.addEventListener("resize", () => {
                            V != F.getWidthBrowser() && (V = F.getWidthBrowser());
                        }),
                        F.addEvent(document, "click", "#announcement-bar--close", (e) => {
                            e.preventDefault();
                            let t = e.target.closest("[data-section-type]");
                            F.isExist(t) && F.fadeOut(t);
                        });
                },
                init: function () {
                    (V = F.getWidthBrowser()), this.initEvents(), this.initCountdown(), this.initCountryProvinceSelector(), this.resetCollectionPagination();
                },
            },
            U = W;
        const J = z.convert;
        var K = {
                settings: {
                    dialog: "cartNoti",
                    cartDrawer: "cartShopping",
                    cartCount: "[data-cart-count]",
                    total: "[data-cart-total]",
                    removeItem: "[data-item-remove]",
                    removeAll: "[data-cart-remove-all]",
                    waitingClass: "cart-waiting",
                    cartBody: "[data-cart-body]",
                    lineItem: "[data-line-item]",
                    itemKey: "[data-item-key]",
                    itemLinePrice: "[data-item-line-price]",
                    itemQty: "[data-item-qty]",
                    replaceContent: "[data-cart-replace]",
                    cartAction: theme.cart.action || "cart",
                    locale: "/" == theme.routes.root_url ? "" : theme.routes.root_url,
                },
                init: function () {
                    this.initEvents();
                },
                initEvents: function () {
                    let e = this,
                        t = e.settings;
                    document.getElementById(t.dialog);
                    F.addEvent(document, "click", ".add-to-cart", async (n) => {
                        let r = n.target;
                        if (r.classList.contains("btn-require-options"))
                            return n.preventDefault(), alert("Some required options have been left empty, unselected, or wrongly filled", "required-options"), F.scrollTo(document.querySelector(".product-form-cart [data-product-form]")), !1;
                        if (theme.cart.ajax && "cart" != t.cartAction) {
                            if ((n.preventDefault(), e.buttonLoading(r), null != r.closest(t.replaceContent))) {
                                let e = r.closest(t.replaceContent).dataset.itemKey;
                                try {
                                    await H(e);
                                } catch (e) {
                                    console.log(e);
                                }
                            }
                            e.addCart(r);
                        }
                    }),
                        F.addEvent(document, "click", ".btn-link-cart:not(.soldout)", (t) => {
                            t.preventDefault();
                            let n = t.target,
                                r = n.closest("[data-product-card]");
                            if ((e.buttonLoading(n), !F.isExist(r))) return;
                            let i = r.querySelector('form button[type="submit"]');
                            F.isExist(i) && i.click();
                        }),
                        F.addEvent(document, "click", '[data-dialog-trigger="#cartShopping"]', async (t) => {
                            await e.getCartDrawer(), U.triggerDialog(e.settings.cartDrawer);
                        });
                    theme.cart.ajax_change_qty &&
                        F.addEvent(
                            document,
                            "keyup",
                            "[data-quantity] input",
                            F.debounceTime(300, (n) => {
                                n.preventDefault();
                                let r = n.target,
                                    i = (r.value, +r.value || 1),
                                    o = +r.getAttribute("min") || 0;
                                r.hasAttribute("disabled") || (i < o && (r.value = o), r.hasAttribute(t.itemKey.replace(/\[|\]/g, ""), "") && i >= o && e.quantityChange(r));
                            })
                        ),
                        F.addEvent(
                            document,
                            "click",
                            "[data-quantity] a.qty-plus, [data-quantity] a.qty-minus",
                            F.debounceTime(0, (n) => {
                                n.preventDefault();
                                let r = n.target,
                                    i = r.closest("[data-quantity]").querySelector("input"),
                                    o = +i.value,
                                    a = +i.value,
                                    s = +i.getAttribute("min") || 0,
                                    c = +i.getAttribute("max") || null;
                                if (!i.hasAttribute("disabled")) {
                                    if (r.classList.contains("qty-plus")) {
                                        if (null != c && a + 1 > c) return (e.currentLine = r.closest(t.lineItem)), void e.showNotify();
                                        a += 1;
                                    } else a > s && (a -= 1);
                                    (i.value = a),
                                        theme.cart.ajax_change_qty &&
                                            i.hasAttribute(t.itemKey.replace(/\[|\]/g, ""), "") &&
                                            a >= s &&
                                            o != a &&
                                            (null !== e.waitQuantityUpdate && clearTimeout(e.waitQuantityUpdate),
                                            (e.waitQuantityUpdate = setTimeout(function () {
                                                e.quantityChange(i), (e.waitQuantityUpdate = null);
                                            }, 500)));
                                }
                            })
                        ),
                        F.addEvent(document, "click", t.removeItem, (n) => {
                            n.preventDefault();
                            let r = n.target,
                                i = r.getAttribute("data-item-key");
                            r.classList.add("running"),
                                F.fadeOut(r.closest(t.lineItem)),
                                H(i)
                                    .then((n) => {
                                        r.closest(t.lineItem).remove(), "cart" == theme.template ? e.updateCart(n) : e.updateCartState(n);
                                    })
                                    .catch((e) => {
                                        console.log(e);
                                    });
                        }),
                        F.addEvent(document, "click", ".clear-cart-items", (t) => {
                            t.preventDefault(),
                                B().then((t) => {
                                    e.updateCart(t);
                                });
                        });
                    let n = (e) => {
                        e.preventDefault(),
                            $({ pagination: null, view_cata: null }).then((e) => {
                                window.location.href = "/checkout";
                            });
                    };
                    F.addEvent(document, "click", 'a[href="/checkout"]', n);
                    document.querySelector("[data-bundle-submit]");
                    F.addEvent(document, "click", "[data-bundle-submit]", (t) => {
                        t.preventDefault();
                        let n = t.target;
                        e.addBundleToCart(n);
                    });
                    let r = document.querySelector('textarea[name="note"]');
                    null != r &&
                        (r.addEventListener("focus", function (e) {
                            this.closest("div").classList.add("note-active");
                        }),
                        r.addEventListener("blur", function (e) {
                            this.closest("div").classList.remove("note-active");
                        }));
                    let i = document.getElementById("stickyAddCartBtn");
                    null != i &&
                        i.addEventListener("click", function (t) {
                            i.hasAttribute("disabled") || i.classList.contains("btn-require-options") || e.buttonLoading(i), document.querySelector("[item-cart]").querySelector('button[type="submit"]').click();
                        });
                },
                addCart: function (e) {
                    let t = this,
                        n = this.settings,
                        r = e.closest("[data-product-form]");
                    null !== r &&
                        I(r).then(
                            (e) => {
                                "checkout" != n.cartAction
                                    ? t
                                          .getCartState()
                                          .then(async function (r) {
                                              if ("drawer" == n.cartAction) {
                                                  await t.getCartDrawer(),
                                                      Array.prototype.forEach.call(document.querySelectorAll(".is-open"), (e) => {
                                                          let t = e.querySelector("[data-dialog-close]");
                                                          null !== t && t.click();
                                                      });
                                                  let r = document.querySelector(`#${t.settings.cartDrawer} [name="quantity"][data-item-key="${e.key}"]`);
                                                  if (null !== r)
                                                      if (t.cartDrawerEl.classList.contains("js-ajax-cart")) r.setAttribute("value", e.quantity);
                                                      else {
                                                          r.innerHTML = e.quantity;
                                                          let t = r.closest(n.lineItem).querySelector("[data-item-qty-label]");
                                                          null != t && (t.innerHTML = e.quantity > 1 ? theme.cart.items : theme.cart.item);
                                                      }
                                                  else {
                                                      let r = await fetch(`${t.settings.locale}/products/${e.handle}/${e.id}?view=include.cart-line-item`);
                                                      (r = await r.text()),
                                                          document.getElementById(t.settings.cartDrawer).querySelector(n.cartBody).insertAdjacentHTML("afterbegin", r),
                                                          Array.prototype.forEach.call(document.querySelectorAll(".cart-item-block"), (e, t) => {
                                                              e.classList = `${e.dataset.class} animation-fade-index-${t}`;
                                                          }),
                                                          J(n.cartBody + " .money");
                                                  }
                                                  U.triggerDialog(n.cartDrawer);
                                              } else {
                                                  let r = document.getElementById(t.settings.dialog);
                                                  if ((null !== r && r.remove(), null == document.getElementById("cartDialogStyle"))) {
                                                      let e = document.createElement("link");
                                                      (e.type = "text/css"), (e.id = "cartDialogStyle"), (e.rel = "stylesheet"), (e.media = "all"), (e.href = theme.resource.cart_dialog.css), document.body.appendChild(e);
                                                  }
                                                  fetch(`${t.settings.locale}/products/${e.handle}/${e.id}?view=include.dialog-cart`)
                                                      .then((e) => e.text())
                                                      .then((e) => {
                                                          document.body.insertAdjacentHTML("beforeend", e), U.initSlider(document.getElementById(n.dialog)), J(`#${n.dialog} .money`), U.triggerDialog(n.dialog);
                                                      });
                                              }
                                              t.updateCart(r);
                                          })
                                          .catch((e) => {
                                              console.error("Error:", e), t.showNotify(e);
                                          })
                                    : (window.location.href = "/checkout");
                            },
                            (e) => {
                                e.json().then((e) => {
                                    console.error("Error:", e), t.showNotify(e.description), t.updateCartState();
                                });
                            }
                        );
                },
                addBundleToCart: function (e) {
                    let t = this,
                        n = this.settings,
                        r = e.closest("[data-bundle-container]").querySelectorAll('input[name="bundleGroup"]:checked');
                    if (!r.length) return;
                    e.classList.add(n.waitingClass);
                    let i = [];
                    r.forEach((e) => {
                        i.push({ id: +e.dataset.id, quantity: 1 });
                    }),
                        fetch(theme.routes.cart_add_url + ".js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: i }) })
                            .then((e) => {
                                "cart" != n.cartAction
                                    ? "checkout" != n.cartAction
                                        ? e
                                              .json()
                                              .then(async (e) => {
                                                  if ("drawer" == n.cartAction)
                                                      if (422 == e.status) t.showNotify(e.description);
                                                      else {
                                                          await t.getCartDrawer();
                                                          let r = [];
                                                          if (
                                                              (e.items.length &&
                                                                  e.items.forEach(async (e) => {
                                                                      let n = document.querySelector(`#${t.settings.cartDrawer} [name="quantity"][data-item-key="${e.key}"]`);
                                                                      null !== n
                                                                          ? n.setAttribute("value", e.quantity)
                                                                          : r.push(
                                                                                new Promise((n, r) => {
                                                                                    fetch(`${t.settings.locale}/products/${e.handle}/${e.id}?view=include.cart-line-item`)
                                                                                        .then((e) => e.text())
                                                                                        .then((e) => {
                                                                                            n(e);
                                                                                        });
                                                                                })
                                                                            );
                                                                  }),
                                                              r.length)
                                                          ) {
                                                              let e = await Promise.all(r);
                                                              document.getElementById(t.settings.cartDrawer).querySelector(n.cartBody).insertAdjacentHTML("afterbegin", e.join("")),
                                                                  Array.prototype.forEach.call(document.querySelectorAll(".cart-item-block"), (e, t) => {
                                                                      e.classList = `${e.dataset.class} animation-fade-index-${t}`;
                                                                  });
                                                          }
                                                          U.triggerDialog(n.cartDrawer);
                                                      }
                                                  else {
                                                      let n = 422 == e.status ? e.description : theme.cart.success_add_cart;
                                                      t.showNotify(n);
                                                  }
                                                  let r = await t.getCartState();
                                                  t.updateCart(r);
                                              })
                                              .catch((e) => {
                                                  console.log(e);
                                              })
                                        : (window.location.href = "/checkout")
                                    : (window.location.href = theme.routes.cart_url);
                            })
                            .catch((r) => {
                                console.error("Error:", error), t.showNotify(error), e.classList.remove(n.waitingClass), t.updateCartState();
                            });
                },
                quantityChange: function (e) {
                    let t = this,
                        n = e.getAttribute(t.settings.itemKey.replace(/\[|\]/g, "")),
                        r = +e.value;
                    (function (e, t) {
                        return (
                            j(e),
                            P(t),
                            M(e).then(function (e) {
                                return O(e, t);
                            })
                        );
                    })(n, { quantity: r }).then((i) => {
                        let o = i.items.find((e) => e.key == n).quantity;
                        o == r ? K.updateCart(i) : (e.setAttribute("value", o), (t.currentLine = e.closest(t.settings.lineItem)), (e.value = o), t.showNotify());
                    });
                },
                buttonLoading: function (e, t = !0) {
                    let n = this.settings.waitingClass;
                    t ? e.classList.add(n) : e.classList.remove(n);
                },
                getCartState: function () {
                    return new Promise((e, t) => {
                        k()
                            .then(async (t) => {
                                e(t);
                            })
                            .catch((e) => {
                                t(e);
                            });
                    });
                },
                getCartDrawer: function () {
                    let e = this,
                        t = document.getElementById(e.settings.cartDrawer);
                    return new Promise((n, r) => {
                        if (null === t) {
                            if (null == document.getElementById("cartDrawerStyle")) {
                                let e = document.createElement("link");
                                (e.type = "text/css"), (e.id = "cartDrawerStyle"), (e.rel = "stylesheet"), (e.media = "all"), (e.href = theme.resource.cart_drawer.css), document.body.appendChild(e);
                            }
                            fetch(theme.routes.search_url + "?view=include.cart-drawer")
                                .then((e) => e.text())
                                .then((t) => {
                                    document.body.insertAdjacentHTML("beforeend", t),
                                        J(`#${e.settings.cartDrawer} .money`),
                                        (e.cartDrawerEl = document.getElementById(e.settings.cartDrawer)),
                                        document.body.classList.remove("lazy-loading"),
                                        n(0);
                                })
                                .catch((e) => {
                                    r(e);
                                });
                        } else n(0);
                    });
                },
                updateCart: async function (e) {
                    let t = this,
                        n = this.settings;
                    if ("cart" == theme.template)
                        if (e.item_count > 0)
                            e.items.forEach((e) => {
                                let t = document.querySelector(`[data-item-key="${e.key}"]`);
                                if (null != t) {
                                    let r = t.closest(n.lineItem).querySelector(n.itemLinePrice);
                                    null != r && (r.innerHTML = T(e.line_price, theme.currency.moneyFormat));
                                }
                            }),
                                J(".cart-section span.money");
                        else {
                            document.querySelector(n.cartBody).innerHTML = theme.cartPage.empty || "";
                        }
                    else if ("drawer" == n.cartAction) {
                        if ((await t.getCartDrawer(), e.item_count > 0)) {
                            e.items.forEach((e) => {
                                let n = document.querySelector(`#${t.settings.cartDrawer} [name="quantity"][data-item-key="${e.key}"]`);
                                null != n && n.setAttribute("value", e.quantity);
                            });
                            let r = document.getElementById("cart-drawer-empty");
                            null !== r && r.remove(), t.cartDrawerEl.querySelector(n.removeAll).classList.remove("hide"), t.cartDrawerEl.querySelector('button[name="checkout"]').classList.remove("hide");
                        } else
                            (t.cartDrawerEl.querySelector(n.cartBody).innerHTML = `<span id="cart-drawer-empty">${theme.cart.empty}<span>`),
                                t.cartDrawerEl.querySelector(n.removeAll).classList.add("hide"),
                                t.cartDrawerEl.querySelector('button[name="checkout"]').classList.add("hide");
                        J(`#${n.cartDrawer} .money`);
                    }
                    t.updateCartState(e);
                  setTimeout(function(){
         if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
                  typeof BOLD.common.eventEmitter.emit === 'function'){
                BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
 }


        },1500);
                },
                updateCartState: function (e) {
                    let t = this.settings,
                        n = document.querySelectorAll("." + t.waitingClass),
                        r = document.getElementById("lineCartError");
                    if (
                        (Array.prototype.forEach.call(n, (e) => {
                            K.buttonLoading(e, !1);
                        }),
                        null != r && r.remove(),
                        null == e)
                    )
                        return;
                    let i = document.querySelectorAll(t.cartCount),
                        o = document.querySelectorAll(t.total);
                    Array.prototype.forEach.call(i, (t) => {
                        t.innerHTML = e.item_count;
                    }),
                        Array.prototype.forEach.call(o, (t) => {
                            t.innerHTML = T(e.total_price, theme.currency.moneyFormat);
                        }),
                        J(t.total + " .money");
                  
                  
                },
                showNotify: async function (e, t = null) {
                    let n = this,
                        r = n.settings,
                        i = e || theme.cart.error_add_cart,
                        o = document.getElementById("lineCartError");
                    if ((null != o && o.remove(), null != n.currentLine)) return n.currentLine.insertAdjacentHTML("beforeend", `<span id="lineCartError">${i}</span>`), void (n.currentLine = null);
                    let a = document.getElementById("dialogNotify");
                    null != a && a.remove();
                    let s = await fetch(theme.routes.search_url + "?view=dialog.notification"),
                        c = await s.text();
                    document.body.insertAdjacentHTML("beforeend", c),
                        (a = document.getElementById("dialogNotify")),
                        null != t && (a.dataset.dialogType = t),
                        (a = a.querySelector("[data-notify-content]")),
                        (a.innerHTML = i),
                        U.triggerDialog("dialogNotify"),
                        Array.prototype.forEach.call(document.querySelectorAll("." + r.waitingClass), (e) => {
                            K.buttonLoading(e, !1);
                        });
                },
            },
            Q = K;
        function X() {
            var e = Error.call(this);
            return (e.name = "Server error"), (e.message = "Something went wrong on the server"), (e.status = 500), e;
        }
        function G(e) {
            var t = Error.call(this);
            return (t.name = "Not found"), (t.message = "Not found"), (t.status = e), t;
        }
        function Z() {
            var e = Error.call(this);
            return (e.name = "Server error"), (e.message = "Something went wrong on the server"), (e.status = 500), e;
        }
        function ee(e) {
            var t = Error.call(this);
            return (t.name = "Content-Type error"), (t.message = "Content-Type was not provided or is of wrong type"), (t.status = e), t;
        }
        function te(e) {
            var t = Error.call(this);
            return (t.name = "JSON parse error"), (t.message = "JSON syntax error"), (t.status = e), t;
        }
        function ne(e, t, n, r) {
            var i = Error.call(this);
            return (i.name = t), (i.message = n), (i.status = e), (i.retryAfter = r), i;
        }
        function re(e, t, n) {
            var r = Error.call(this);
            return (r.name = t), (r.message = n), (r.status = e), r;
        }
        function ie(e, t, n) {
            var r = Error.call(this);
            return (r.name = t), (r.message = n), (r.status = e), r;
        }
        function oe() {
            this.events = {};
        }
        function ae(e) {
            (this.eventName = e), (this.callbacks = []);
        }
        function se(e) {
            (this._store = {}), (this._keys = []), e && e.bucketSize ? (this.bucketSize = e.bucketSize) : (this.bucketSize = 20);
        }
        function ce(e, t) {
            var n = "";
            return (
                (t = t || null),
                Object.keys(e).forEach(function (r) {
                    var i = r + "=";
                    switch (
                        (t && (i = t + "[" + r + "]"),
                        (function (e) {
                            return Object.prototype.toString.call(e).slice(8, -1).toLowerCase();
                        })(e[r]))
                    ) {
                        case "object":
                            n += ce(e[r], t ? i : r);
                            break;
                        case "array":
                            n += i + "=" + e[r].join(",") + "&";
                            break;
                        default:
                            t && (i += "="), (n += i + encodeURIComponent(e[r]) + "&");
                    }
                }),
                n
            );
        }
        (oe.prototype.on = function (e, t) {
            var n = this.events[e];
            n || ((n = new ae(e)), (this.events[e] = n)), n.registerCallback(t);
        }),
            (oe.prototype.off = function (e, t) {
                var n = this.events[e];
                n && n.callbacks.indexOf(t) > -1 && (n.unregisterCallback(t), 0 === n.callbacks.length && delete this.events[e]);
            }),
            (oe.prototype.dispatch = function (e, t) {
                var n = this.events[e];
                n && n.fire(t);
            }),
            (ae.prototype.registerCallback = function (e) {
                this.callbacks.push(e);
            }),
            (ae.prototype.unregisterCallback = function (e) {
                var t = this.callbacks.indexOf(e);
                t > -1 && this.callbacks.splice(t, 1);
            }),
            (ae.prototype.fire = function (e) {
                this.callbacks.slice(0).forEach(function (t) {
                    t(e);
                });
            }),
            (se.prototype.set = function (e, t) {
                if (this.count() >= this.bucketSize) {
                    var n = this._keys.splice(0, 1);
                    this.delete(n);
                }
                return this._keys.push(e), (this._store[e] = t), this._store;
            }),
            (se.prototype.get = function (e) {
                return this._store[e];
            }),
            (se.prototype.has = function (e) {
                return Boolean(this._store[e]);
            }),
            (se.prototype.count = function () {
                return Object.keys(this._store).length;
            }),
            (se.prototype.delete = function (e) {
                var t = Boolean(this._store[e]);
                return delete this._store[e], t && !this._store[e];
            });
        var le,
            ue,
            de,
            he =
                ((le = function (e, t, n, r, i) {
                    var o = new XMLHttpRequest(),
                        a = e + "/suggest.json";
                    (o.onreadystatechange = function () {
                        if (o.readyState !== XMLHttpRequest.DONE);
                        else {
                            var e = o.getResponseHeader("Content-Type");
                            if (o.status >= 500) return void i(new Z());
                            if (404 === o.status) return void i(new G(o.status));
                            if ("string" != typeof e || null === e.toLowerCase().match("application/json")) return void i(new ee(o.status));
                            if (417 === o.status) {
                                try {
                                    var t = JSON.parse(o.responseText);
                                    i(new re(o.status, t.message, t.description));
                                } catch (e) {
                                    i(new te(o.status));
                                }
                                return;
                            }
                            if (422 === o.status) {
                                try {
                                    var a = JSON.parse(o.responseText);
                                    i(new ie(o.status, a.message, a.description));
                                } catch (e) {
                                    i(new te(o.status));
                                }
                                return;
                            }
                            if (429 === o.status) {
                                try {
                                    var s = JSON.parse(o.responseText);
                                    i(new ne(o.status, s.message, s.description, o.getResponseHeader("Retry-After")));
                                } catch (e) {
                                    i(new te(o.status));
                                }
                                return;
                            }
                            if (200 === o.status) {
                                try {
                                    var c = JSON.parse(o.responseText);
                                    (c.query = n), r(c);
                                } catch (e) {
                                    i(new te(o.status));
                                }
                                return;
                            }
                            try {
                                var l = JSON.parse(o.responseText);
                                i(new X(o.status, l.message, l.description));
                            } catch (e) {
                                i(new te(o.status));
                            }
                        }
                    }),
                        o.open("get", a + "?q=" + encodeURIComponent(n) + "&" + t),
                        o.setRequestHeader("Content-Type", "application/json"),
                        o.send();
                }),
                (ue = 10),
                (de = null),
                function () {
                    var e = this,
                        t = arguments;
                    clearTimeout(de),
                        (de = setTimeout(function () {
                            (de = null), le.apply(e, t);
                        }, ue || 0));
                });
        function me(e) {
            if (!e) throw new TypeError("No config object was specified");
            var t = e;
            (this._retryAfter = null),
                (this._currentQuery = null),
                (this.dispatcher = new oe()),
                (this.cache = new se({ bucketSize: 40 })),
                (this.searchPath = t.search_path || "/search"),
                t.search_path && delete t.search_path,
                (this.configParams = ce(t));
        }
        function ye(e) {
            return "string" != typeof e ? null : e.trim().replace(" ", "-").toLowerCase();
        }
        (me.SEARCH_PATH = "/search"),
            (me.TYPES = { PRODUCT: "product", PAGE: "page", ARTICLE: "article", COLLECTION: "collection" }),
            (me.FIELDS = { AUTHOR: "author", BODY: "body", PRODUCT_TYPE: "product_type", TAG: "tag", TITLE: "title", VARIANTS_BARCODE: "variants.barcode", VARIANTS_SKU: "variants.sku", VARIANTS_TITLE: "variants.title", VENDOR: "vendor" }),
            (me.UNAVAILABLE_PRODUCTS = { SHOW: "show", HIDE: "hide", LAST: "last" }),
            (me.prototype.query = function (e) {
                try {
                    !(function (e) {
                        var t;
                        if (null == e) throw (((t = new TypeError("'query' is missing")).type = "argument"), t);
                        if ("string" != typeof e) throw (((t = new TypeError("'query' is not a string")).type = "argument"), t);
                    })(e);
                } catch (e) {
                    return void this.dispatcher.dispatch("error", e);
                }
                if ("" === e) return this;
                this._currentQuery = ye(e);
                var t = this.cache.get(this._currentQuery);
                return t
                    ? (this.dispatcher.dispatch("success", t), this)
                    : (he(
                          this.searchPath,
                          this.configParams,
                          e,
                          function (e) {
                              this.cache.set(ye(e.query), e), ye(e.query) === this._currentQuery && ((this._retryAfter = null), this.dispatcher.dispatch("success", e));
                          }.bind(this),
                          function (e) {
                              e.retryAfter && (this._retryAfter = e.retryAfter), this.dispatcher.dispatch("error", e);
                          }.bind(this)
                      ),
                      this);
            }),
            (me.prototype.on = function (e, t) {
                return this.dispatcher.on(e, t), this;
            }),
            (me.prototype.off = function (e, t) {
                return this.dispatcher.off(e, t), this;
            });
        const pe = [13, 38, 40, 27, 8],
            fe = theme.search,
            ge = "product" == fe.type ? ["product"] : ["product", "collection", "article", "page"];
        var ve = new me({
            search_path: theme.routes.search_url,
            resources: { type: ge, limit: fe.limit, options: { unavailable_products: fe.unavailable_result }, fields: [me.FIELDS.TITLE, me.FIELDS.PRODUCT_TYPE, me.FIELDS.VARIANTS_TITLE] },
        });
        ve.on("success", async function (e) {
            be.settings;
            let t = e.resources.results,
                n = [],
                r = theme.routes.search_url.replace(me.SEARCH_PATH, "");
            for (let e in t)
                t[e].length > 0 &&
                    t[e].forEach((t) => {
                        n.push(
                            new Promise((n, i) => {
                                let o = t.handle,
                                    a = `${r}/${e}/${o}?view=include.search-item`;
                                "articles" === e && ((o = t.url.slice(0, t.url.indexOf(t.handle) + t.handle.length)), (a = `${r}${o}?view=include.search-item`)),
                                    fetch(a)
                                        .then((e) => e.text())
                                        .then((e) => n(e))
                                        .catch((e) => i(e));
                            })
                        );
                    });
            let i = await Promise.all(n);
            null != be.searchResultContainer && be.showResults(i.join(""));
        }),
            ve.on("error", function (e) {
                console.error(e);
            });
        var be = {
                settings: {
                    resultLayout: "#searchResultLayout",
                    searchDialog: "#searchModal",
                    container: "[data-search-container]",
                    resultTarget: "[data-search-result]",
                    type: "[data-result-type]",
                    item: ".search-result-item",
                    title: "[data-item-title]",
                  	boldOptions: "[bold-options]",
                    url: "[data-item-url]",
                    image: "[data-item-image]",
                    imageWrapper: ".result-item-image",
                    price: "[data-item-price]",
                    soldout: "[data-item-soldout]",
                    submit: "[data-search-submit]",
                },
                refreshSearch: () => {
                    let e = document.querySelectorAll(".search-is-active, .search-is-typing");
                    e.length &&
                        e.forEach((e) => {
                            e.classList.remove("search-is-active", "search-is-typing");
                        });
                },
                handleEvent: function () {
                    let e = this.settings,
                        t = document.querySelector(e.searchDialog);
                    F.addEvent(document, "click", 'input[name="q"]', async (n) => {
                        let r = n.target,
                            i = r.closest(e.container);
                        if (null != t.querySelector(".lazyload[data-include]")) {
                            t.classList.add("lazyqueue-active");
                            await F.activeLazyload(t, () => {
                                t.classList.remove("lazyqueue-active");
                            });
                        }
                        be.refreshSearch(),
                            i.classList.add("search-is-active"),
                            r.value.length ? i.classList.add("search-is-typing") : i.classList.remove("search-is-typing"),
                            F.getWidthBrowser() < 992 && !F.isExist(r.closest(e.searchDialog)) && U.triggerDialog(e.searchDialog);
                    }),
                        F.addEvent(
                            document,
                            "keyup",
                            'input[name="q"]',
                            F.debounceTime(500, (t) => {
                                if (pe.some((e) => e == t.keyCode)) return;
                                let n = t.target,
                                    r = n.closest(e.container);
                                n.value.length ? r.classList.add("search-is-typing") : r.classList.remove("search-is-typing"), be.fetchData(n, n.value);
                            })
                        ),
                        F.addEvent(document, "click", ".btn-search-clear", (n) => {
                            n.preventDefault();
                            let r = t.querySelector('input[name="q"]'),
                                i = r.closest(e.container);
                            (t.querySelector(e.resultTarget).innerHTML = ""), (r.value = ""), r.focus(), i.classList.remove("search-is-typing");
                        }),
                        F.addEvent(document, "click", e.submit, (t) => {
                            t.preventDefault();
                            let n = t.target.closest(e.container);
                            if (null == n) return;
                            let r = n.querySelector("form");
                            null != r && r.submit();
                        }),
                        document.body.addEventListener("click", (e) => {
                            let t = document.querySelectorAll(".search-is-active");
                            t.length &&
                                !F.isExist(e.target.closest(".search-is-active")) &&
                                t.forEach((e) => {
                                    e.classList.remove("search-is-active");
                                });
                        });
                },
                fetchData: function (e, t) {
                    let n = theme.search,
                        r = be.settings,
                        i = e.closest(r.container),
                        o = i.querySelector(r.resultTarget);
                    if (((this.searchResultContainer = o), i.classList.contains("search-is-active") || (be.refreshSearch(), i.classList.add("search-is-active")), i.classList.add("search-loading"), 0 == e.value.length))
                        return (o.innerHTML = ""), void i.classList.remove("search-loading");
                    if (e.value.length > 0 && e.value.length < 2) return (o.innerHTML = `<li class="result-notify">${n.notify_character}</li>`), void i.classList.remove("search-loading");
                    let a = "product" == n.type ? ["product"] : ["product", "article", "page", "collection"];
                    theme.routes.search_url, n.limit, n.unavailable_result;
                    ve.query(t);
                },
                showResults: function (e) {
                    let t = this.settings,
                        n = this.searchResultContainer.closest(t.container),
                        r = n.querySelector(t.resultTarget);
                    if ("" != e) {
                        let n = document.querySelector(t.resultLayout + " .search-redirect");
                        F.isExist(n) && (e += n.outerHTML), (r.innerHTML = e), z.convert(t.resultTarget + " .money");
                    } else r.innerHTML = `<li class="result-notify">${fe.no_result}</li>`;
                    n.classList.remove("search-loading");
                },
                init: function () {
                    "search" != theme.template && this.handleEvent();
                },
            },
            we = be,
            Se = {
                settings: { menuMobile: "#menuMobile", subClass: ".sub-opened", layerClass: ".mobile-layer", activeClass: "active" },
                init: function () {
                    (this.header = document.querySelector("#header-style")), this.initEvents(), this.mobileMenu_events(), this.sticky(), theme.live && this.initMobileBar();
                },
                initEvents: function () {
                    let e = this,
                        t = e.settings,
                        n = e.header.querySelectorAll("li.nav-item");
                    if (n.length) {
                        let t = e.header.closest("header");
                        n.length &&
                            n.forEach((e) => {
                                e.addEventListener("mouseenter", (n) => {
                                    null != e.querySelector(".lazyload-include") && (t.classList.add("nav-is-hover"), e.classList.add("is-hover"));
                                }),
                                    e.addEventListener("mouseleave", (n) => {
                                        t.classList.remove("nav-is-hover"), e.classList.remove("is-hover");
                                    });
                            });
                    }
                    let r = document.querySelectorAll('nav a[href^="#"]:not([href="#"])');
                    r.length &&
                        r.forEach((e) => {
                            e.addEventListener("click", (e) => {
                                e.preventDefault();
                                let t = e.currentTarget.getAttribute("href");
                                null != document.querySelector(t) && F.scrollTo(t);
                            });
                        }),
                        F.addEvent(document.querySelector(t.menuMobile), "click", "a", (e) => {
                            let t = e.target.getAttribute("href");
                            if (null != t && "#" != t && null != t.match(/^#/g)) {
                                e.preventDefault(), null != document.querySelector(t) && F.scrollTo(t);
                            }
                        });
                },
                setMinHeight: function () {
                    let e = document.querySelectorAll(".header-block");
                    (e = [...e].filter((e) => null != e.offsetParent)[0]),
                        (e = e.querySelector(":scope > div")),
                        document.querySelector(".header-sticky").classList.contains("header-overlay") || e.parentNode.style.setProperty("min-height", e.clientHeight + "px");
                },
                sticky: function () {
                    let e = document.querySelector(".header-sticky");
                    if (null == e) return;
                    let t = document.querySelectorAll(".header-block");
                    t = [...t].filter((e) => null != e.offsetParent)[0];
                    let n = t.offsetTop + 100;
                    window.addEventListener("load", this.setMinHeight),
                        window.addEventListener("resize", this.setMinHeight),
                        window.addEventListener(
                            "scroll",
                            (t) => {
                                window.scrollY > n ? e.classList.add("active") : e.classList.remove("active");
                            },
                            { passive: !1 }
                        );
                },
                mobileBar: () => {
                    let e = document.getElementById("mobile-bar"),
                        t = window.scrollY + F.getHeightBrowser(),
                        n = document.body.clientHeight;
                    F.getWidthBrowser() >= 992 || null == e || !JSON.parse(e.getAttribute("data-hide-bottom")) || (t > n - 250 ? e.classList.add("d-none") : e.classList.remove("d-none"));
                },
                initMobileBar: function () {
                    let e = this;
                    window.addEventListener(
                        "scroll",
                        () => {
                            e.mobileBar();
                        },
                        { passive: !1 }
                    );
                },
                mobileMenu_events: function () {
                    let e = this.settings;
                    F.addEvent(document, "click", "[data-submenu-link]", (t) => {
                        let n = document.querySelector(e.menuMobile),
                            r = t.target,
                            i = r.getAttribute("data-submenu-link"),
                            o = n.querySelector(`[data-target="${i}"]`);
                        if (!F.isExist(o)) return;
                        let a = r.closest(`${e.layerClass}.${e.activeClass}:not(.main-layer)`);
                        F.isExist(a) && a.classList.add(e.subClass.replace(".", "")), o.classList.add(e.activeClass), r.closest(e.layerClass).classList.remove(e.activeClass);
                    }),
                        F.addEvent(document, "click", ".mobile-layer-title", (t) => {
                            let n = document.querySelector(e.menuMobile);
                            t.target.closest(e.layerClass).classList.remove(e.activeClass);
                            let r = n.querySelector(e.subClass);
                            if (F.isExist(r)) return r.classList.remove(e.subClass.replace(".", "")), void r.classList.add(e.activeClass);
                            n.querySelector(e.layerClass).classList.add(e.activeClass);
                        });
                },
            };
        "shopify" == theme.product.review_type &&
            ((window.badgesCallback = function (e) {
                var t;
                return (
                    (t = e.badges),
                    SPR.$.map(SPR.badgeEls, function (e) {
                        var n;
                        if (((n = SPR.$(e).attr("data-id")), void 0 !== t[n])) return SPR.$(e).replaceWith(t[n]), SPR.triggerEvent("spr:badge:loaded", { id: n });
                    })
                );
            }),
            (window.loadBadges = function () {
                var e, t;
                if (
                    0 <
                    (e = this.$.map(
                        this.badgeEls,
                        ((t = this),
                        function (e) {
                            return t.$(e).attr("data-id");
                        })
                    )).length
                )
                    for (; 0 < e.splice(0, 7).length; ) {
                        let e = document.createElement("script");
                        (e.src = `${SPR.api_url}/reviews/badges?callback=badgesCallback&shop=${Shopify.shop}&${SPR.$.map(SPR.badgeEls, (e) => "&product_ids[]=" + e.getAttribute("data-id"))}`),
                            e.addEventListener("load", function () {
                                this.remove();
                            }),
                            document.head.append(e);
                    }
            })),
            a("header", {
                onLoad: function () {
                    Se.init();
                },
                onBlockSelect: function (e) {
                    let t = e.target;
                    t.closest(".nav-dd, .nav-mm").classList.add("adm-active"), t.closest("header").classList.add("nav-is-hover");
                },
                onBlockDeselect: function (e) {
                    let t = e.target;
                    t.closest(".nav-dd, .nav-mm").classList.remove("adm-active"), t.closest("header").classList.remove("nav-is-hover");
                },
            }),
            a("mobile-bar", {
                onLoad: function () {
                    (this.mobileBar = document.getElementById("mobile-bar")), Se.initMobileBar();
                },
                onSelect: function () {
                    this.mobileBar.classList.add("d-block");
                },
                onDeselect: function () {
                    this.mobileBar.classList.remove("d-block");
                },
                onBlockSelect: function () {
                    this.mobileBar.classList.add("d-block");
                },
                onBlockDeselect: function () {
                    this.mobileBar.classList.add("d-block");
                },
            }),
            s("*"),
            U.init(),
            z.init(),
            Q.init(),
            we.init(),
            (theme.addEvent = function (e, t, n, r) {
                e.addEventListener(
                    t,
                    function (e) {
                        e.target.matches(n + ", " + n + " *") && r.apply(e.target.closest(n), arguments);
                    },
                    !1
                );
            }),
            theme.addEvent(document, "click", ".swt-element", (e) => {
                let t = e.target,
                    n = t.closest("[data-card-swatch]"),
                    r = t.closest("[data-product-card]"),
                    i = n.getAttribute("data-handle"),
                    o = t.closest(".swatch-container").querySelector(".swt-element.active");
                null != o && o.classList.remove("active"), t.classList.add("active");
                let a = n.querySelectorAll(".swt-element.active"),
                    s = [];
                a.forEach((e, t) => {
                    e.classList.contains("active") && s.push(e.getAttribute("data-value"));
                });
                let c = r.querySelector("[data-item-price]"),
                    l = r.querySelector("[data-item-image]"),
                    u = r.querySelector('select[name="id"]'),
                    d = r.querySelector(".add-to-cart");
                fetch(`${theme.routes.all_products_collection_url}/products/${i}.js`).then((e) => {
                    e.json().then((e) => {
                        let t = e.variants.filter((e) => e.title == s.join(" / "));
                        !t.length && (t = e.variants.filter((e) => e.title.includes(s.join(" / ")))),
                            t.length
                                ? ((t = t[0]),
                                  "function" == typeof Shopify.moneyFormat && null != c && (c.innerHTML = Shopify.moneyFormat(t.price, theme.currency.moneyFormat)),
                                  t.featured_media && null != l && (l.style.backgroundImage = `url('${t.featured_media.preview_image.src}')`),
                                  null != u &&
                                      ((u.value = t.id),
                                      null != d &&
                                          (t.available
                                              ? (d.removeAttribute("disabled"), (d.textContent = theme.cart.available), d.classList.remove("soldout"))
                                              : (d.setAttribute("disabled", "disabled"), (d.textContent = theme.cart.soldout), d.classList.add("soldout")))))
                                : null != d && (d.textContent = theme.cart.unavailable);
                    });
                });
            });
    },
]);
